export const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];


export const MonthNamer = (data) => {
    let tempStatistic = []
    let ancor = 0
    for (let i = 0; i <= 11; i++) {
        let total = 0
        if (data[ancor]) {
            if (data[ancor]["name"] === i.toString()) {
                total += data[ancor]["total"]
                if (ancor < data.length - 1) {
                    ancor += 1
                }
            }
        }
        tempStatistic.push({name: monthNames[i], total: total})

    }
    return tempStatistic
}